import { combineReducers, configureStore } from "@reduxjs/toolkit";
import createIndexedDBStorage from "redux-persist-indexeddb-storage";
import { persistReducer, persistStore, createTransform } from "redux-persist";
import LZString from 'lz-string';

import { portalManagementReducer, portalManagementXReducer } from "./features/portalManagement/portalManagementSlice";
import { systemManagementReducer } from "./features/systemManagement/systemManagementSlice";
import { authenticationReducer } from "./features/authentication/authenticationSlice";

// const compressTransform = createTransform(
//   (inboundState) => LZString.compress(JSON.stringify(inboundState)),
//   (outboundState) => JSON.parse(LZString.decompress(outboundState) || '{}')
// );

const xPersistConfig = {
  key: "portalManagementX",
  storage: createIndexedDBStorage("zintoro-redux-persist"),
  // transforms: [compressTransform],
};

const persistedXReducer = persistReducer(xPersistConfig, portalManagementXReducer);

const persistConfig = {
  key: "root",
  storage: createIndexedDBStorage("zintoro-redux-persist"),
  // Equipment Analytics retired 2026-08-08: every existing snapshot still
  // carries its slice, and combineReducers logs an "Unexpected key" console
  // error on each rehydrate. Migrations run before reconciliation, so the
  // stale key is dropped once and the snapshot self-heals.
  version: 2,
  migrate: (state: any) => {
    if (state && "equipmentManagement" in state) {
      const { equipmentManagement, ...rest } = state;
      return Promise.resolve(rest);
    }
    return Promise.resolve(state);
  },
};

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  systemManagement: systemManagementReducer,
  portalManagement: portalManagementReducer,
  portalManagementX: persistedXReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
      immutableCheck: false,
    });
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
